import { useState, useCallback, useEffect } from 'react';
import companyServices from 'services/company.services';

export default function useGetCompanyMeterClient() {
  const [loading, setLoading] = useState(false);
  const [listCompanyMeterClients, setListCompanyMeterClients] = useState([]);

  const getCompanyMeterClients = useCallback(async () => {
    try {
      setLoading(true);
      const data = await companyServices.listCompanyMeterClient();
      setListCompanyMeterClients(data.items);
    } catch (err) {
      console.error(err.message);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    getCompanyMeterClients();
  }, []);

  return {
    loading,
    listCompanyMeterClients,
    getCompanyMeterClients
  };
}
